import store from '@/store';

// Return a user friendly version of the answers

export default ({ category, questionId, answer }) => {
  const findField = (id, fieldList) => {
    if (!fieldList) return;
    for (const field of fieldList) {
      if (field.FieldId === id) return field;
      if (field && field.AvailableFieldList) {
        const availableFieldListResult = findField(
          id,
          field.AvailableFieldList
        );
        if (availableFieldListResult) return availableFieldListResult;
      }
      if (field.Options) {
        for (const f of field.Options) {
          if (f && f.AvailableFieldList) {
            const optionsResult = findField(id, f.AvailableFieldList);
            if (optionsResult) return optionsResult;
          }
        }
      }
    }
    return;
  };

  const field = findField(
    questionId,
    store.getters.getConfigTemplate[category] && store.getters.getConfigTemplate[category].AvailableFieldList
  );

  if (!field) return answer;

  // Special answer formatting for different config types
  switch (field.Type) {
    case "buttonGroup":
    case "radio":
    case "dropdown": {
      const answerOption = field.Options.find(
        (option) => option.Value.toString() === answer.toString()
      );
      return answerOption !== undefined ? answerOption.Display : "";
    }
    case "checkbox": {
      return answer ? "Checked" : "Unchecked";
    }
    default:
      return answer;
  }
};